import { FC, useContext, useState } from 'react';
import { Card, CardContent, Typography, Button, Grid } from '@material-ui/core';
import { Colors } from '../../helpers/theme';
import { useWeb3 } from '../../services/web3/hooks/useWeb3';
import SubscriptionContext from '../../store/Subscription/SubscriptionContext';
import { TokenDollar } from '../../utils/currency/usd';
import { formatDecimalNumber } from '../../utils/web3/formatBalance';

import useStyles from "../Styles/GainsStyles";
import BuyGainsMenu from './BuyGainsMenu';

interface StakeCardProps {
    toggleModal: (value: boolean) => void;
}

const StakeCardSection: FC<any> = ({ toggleModal }: StakeCardProps) => {

    const { gainsBalance } = useWeb3();
    const { lockedGainsPad } = useContext<any>(SubscriptionContext);
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleBuyClick = (event:any) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    }

    window.addEventListener("scroll", () => {
        if (anchorEl) {
            setAnchorEl(null);
        }
    })

    return (
            <Card style={{
                border: "1px solid " + Colors.secondaryWhite,
                borderRadius: "17px",
                boxShadow: "none",
                width: "100%",
                marginBottom: "20px",
            }}
            elevation={0}
            >
                <CardContent
                    style={{
                        padding: 0,
                    }}
                >
                    <Grid 
                        container
                        xs={12}
                        direction='column'
                    >
                        
                        <Grid 
                            item
                            style={{
                                display: "contents",
                            }}
                        >
                            <Grid container direction='row'>
                                <Grid 
                                    item 
                                    xs={5}
                                    style={{
                                        padding: "15px 0 10px 15px",
                                        color: Colors.greySlate,
                                    }}
                                >
                                    <Typography variant='h5'>
                                        GAINS Balance
                                    </Typography>
                                    <Typography variant="caption" gutterBottom>
                                        On Current Wallet
                                    </Typography>
                                    <Typography color="primary" variant="h4">
                                        {
                                            (gainsBalance && gainsBalance.formatted) 
                                                ? TokenDollar(Number(formatDecimalNumber(gainsBalance.formatted)))
                                                : 'NA'
                                        }
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={1}
                                    style={{ borderRight: '1px solid ' + Colors.secondaryWhite }}
                                >
                                </Grid>
                                <Grid 
                                    item 
                                    xs={5}
                                    style={{
                                        padding: "15px 0 10px 15px",
                                        color: Colors.greySlate,
                                    }}
                                >
                                    <Typography variant='h5'>
                                        GAINS Staked
                                    </Typography>
                                    <Typography variant="caption" gutterBottom>
                                        From All Wallets
                                    </Typography>
                                    <Typography color="primary" variant="h4">
                                        {
                                            TokenDollar(lockedGainsPad)
                                        }
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid 
                            item
                            style={{ borderBottom: "1px solid " + Colors.secondaryWhite}}
                        >
                        </Grid> 
                        <Grid 
                         container 
                         direction='row'
                         item
                         style={{
                            padding: "0.75rem 0.5rem",                 
                        }}
                        >
                        <Grid 
                         item 
                         xs={6}  
                         sm={8}
                         style={{
                            paddingRight: "0.25rem",                 
                        }}> 
                            <Button 
                                variant="contained"
                                fullWidth
                                className={classes.stakeButton}
                                onClick={(e) => toggleModal(true)}
                            >
                                Stake GAINS
                            </Button>
                            </Grid>
                        <Grid 
                          item
                          xs={6}
                          sm={4}
                           style={{
                            paddingLeft: "0.25rem",                 
                        }}>
                            <Button 
                                variant="contained" 
                                fullWidth
                                className={classes.buyButton}
                                onClick={handleBuyClick}
                            >
                            Buy GAINS
                            </Button>
                        </Grid>
                        {open && 
                        <BuyGainsMenu
                         id='buy-gains-menu'
                         open={open}
                         anchorEl={anchorEl}
                         handleClose={() => setAnchorEl(null)}
                        />}
                    </Grid>
                    </Grid>
                </CardContent>
            </Card>
    );
};

export default StakeCardSection;
